<template>
  <div class="open-answer-container">
    <v-textarea
      :value="answer"
      class="text-area"
      placeholder="Insira sua resposta aqui"
      :error="invalidAnswer"
      :error-messages="invalidAnswer ? 'Você atingiu o limite de caracteres.' : ''"
      :counter="characterLimit"
      no-resize
      rows="4"
      outlined
      @input="handleChange"
    >
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: 'OpenAnswer',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      answer: '',
      characterLimit: 2000
    }
  },
  computed: {
    charactersCount() {
      return this.answer.length
    },
    invalidAnswer() {
      return this.charactersCount > this.characterLimit
    }
  },
  watch: {
    question: {
      handler(newVal) {
        this.answer = newVal.answers
      },
      deep: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped lang="scss">
.open-answer-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 12px;
  width: 100%;
}

.text-area {
  width: 100%;
}
</style>
